/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffParticipant } from './StaffParticipant';
import {
    StaffParticipantFromJSON,
    StaffParticipantFromJSONTyped,
    StaffParticipantToJSON,
    StaffParticipantToJSONTyped,
} from './StaffParticipant';
import type { OutreachSummary } from './OutreachSummary';
import {
    OutreachSummaryFromJSON,
    OutreachSummaryFromJSONTyped,
    OutreachSummaryToJSON,
    OutreachSummaryToJSONTyped,
} from './OutreachSummary';
import type { StaffRequest } from './StaffRequest';
import {
    StaffRequestFromJSON,
    StaffRequestFromJSONTyped,
    StaffRequestToJSON,
    StaffRequestToJSONTyped,
} from './StaffRequest';
import type { MedicaidCase } from './MedicaidCase';
import {
    MedicaidCaseFromJSON,
    MedicaidCaseFromJSONTyped,
    MedicaidCaseToJSON,
    MedicaidCaseToJSONTyped,
} from './MedicaidCase';

/**
 * 
 * @export
 * @interface MedicaidCaseWorkspace
 */
export interface MedicaidCaseWorkspace {
    /**
     * 
     */
    _case: MedicaidCase;
    /**
     * 
     */
    participants: Array<StaffParticipant>;
    /**
     * 
     */
    requests: Array<StaffRequest>;
    /**
     * 
     */
    outreach_summary: OutreachSummary;
    /**
     * 
     */
    uncategorized_document_count: number;
    /**
     * 
     */
    unacknowledged_message_count: number;
    /**
     * 
     */
    facility_timezone: string | null;
}

/**
 * Check if a given object implements the MedicaidCaseWorkspace interface.
 */
export function instanceOfMedicaidCaseWorkspace(value: object): value is MedicaidCaseWorkspace {
    if ((!('_case' in (value as Record<string, any>)) && !('case' in (value as Record<string, any>))) || ((value as Record<string, any>)['_case'] === undefined && (value as Record<string, any>)['case'] === undefined)) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('outreach_summary' in value) || value['outreach_summary'] === undefined) return false;
    if (!('uncategorized_document_count' in value) || value['uncategorized_document_count'] === undefined) return false;
    if (!('unacknowledged_message_count' in value) || value['unacknowledged_message_count'] === undefined) return false;
    if (!('facility_timezone' in value) || value['facility_timezone'] === undefined) return false;
    return true;
}

export function MedicaidCaseWorkspaceFromJSON(json: any): MedicaidCaseWorkspace {
    return MedicaidCaseWorkspaceFromJSONTyped(json, false);
}

export function MedicaidCaseWorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseWorkspace {
    if (json == null) {
        return json;
    }
    return {
        
        '_case': MedicaidCaseFromJSON(json['case']),
        'participants': ((json['participants'] as Array<any>).map(StaffParticipantFromJSON)),
        'requests': ((json['requests'] as Array<any>).map(StaffRequestFromJSON)),
        'outreach_summary': OutreachSummaryFromJSON(json['outreach_summary']),
        'uncategorized_document_count': json['uncategorized_document_count'],
        'unacknowledged_message_count': json['unacknowledged_message_count'],
        'facility_timezone': json['facility_timezone'],
    };
}

export function MedicaidCaseWorkspaceToJSON(json: any): MedicaidCaseWorkspace {
    return MedicaidCaseWorkspaceToJSONTyped(json, false);
}

export function MedicaidCaseWorkspaceToJSONTyped(value?: MedicaidCaseWorkspace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'case': MedicaidCaseToJSON(value['_case']),
        'participants': ((value['participants'] as Array<any>).map(StaffParticipantToJSON)),
        'requests': ((value['requests'] as Array<any>).map(StaffRequestToJSON)),
        'outreach_summary': OutreachSummaryToJSON(value['outreach_summary']),
        'uncategorized_document_count': value['uncategorized_document_count'],
        'unacknowledged_message_count': value['unacknowledged_message_count'],
        'facility_timezone': value['facility_timezone'],
    };
}

